export * from './public_api';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/kepler/code/github/expense-manager-firebase/~/angularfire2/database/index.js
// module id = ../../../../angularfire2/database/index.js
// module chunks = 3